import Api from '../utils/Api'
import moment from 'moment'

class RequestsService {

  getNextRequests() {
    return Api.call('/request/get-company-next-requests', 'get')
      .then(res => res.data)
      .catch(err => { throw err })
  }

  getRequestsByMonth(dateStart, dateEnd) {
    return Api.call('/request/get-company-requests-by-month', 'get', { dateStart, dateEnd })
      .then(res => res.data)
      .catch(err => { throw err })
  }

  cancelRequest(params) {
    return Api.call('/request/cancel-request', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  confirmRequest(params) {
    return Api.call('/request/confirm-request', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  createRequest(params) {
    return Api.call('/request/create-company-request', 'post', params, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getAllAdventuresByCompany() {
    return Api.call('/adventure/get-adventure-by-company', 'get')
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getAdventureValidVouchers(params) {
    return Api.call('/request/get-adventure-valid-vouchers', 'get', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getAdventureInvalidValidVouchers(params) {
    return Api.call('/request/get-adventure-invalid-vouchers', 'get', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  validateVoucher(params) {
    return Api.call('/request/validate-voucher', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  cancelVoucher(params) {
    return Api.call('/request/cancel-voucher', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getAllOperatingsByCompany() {
    return Api.call('/operating/get-all-operating-adventure', 'get')
      .then(res => res.data)
      .catch(err => { throw err })
  }
  doCheckIn(pk_reserve) {
    return Api.call('/reserve/check-in-participant', 'post', { pk_reserve })
      .then(res => res.data)
      .catch(err => { throw err })
  }
  sendEmailToUserReserve(data) {
    return Api.call('/request/send-email-for-one-reserve', 'post', data, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  sendEmailToWholeRequestUsers(data) {
    return Api.call('/request/send-email', 'post', data, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  toggleType(params) {
    return Api.call('request/toggle-type', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  confirmChangeMaxOfParticipants(params) {
    return Api.call('/request/change-max-of-participants', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  cancelIndividualReserve(params) {
    return Api.call('/payment/cancel-individual-reserve', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  createReserveForRequest(pk_request, reserve) {
    return Api.call('/request/create-company-reserve', 'post', { ...reserve, pk_request }, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  updateReserve(reserve) {
    return Api.call('/reserve/update-reserve', 'post', reserve, false, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  changeRequestObsInfo(params) {
    return Api.call('/request/update-request-info', 'post', params, null, true)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getAvaiableHoursOfMonthByAdventure(params) {
    return Api.call('/schedule-rule/get-schedule', 'get', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getScheduleOfDate(params) {
    return Api.call('/schedule-rule/get-schedule-of-day', 'get', params)
      .then(res => { 
        // ORDENANDO HORARIOS PELA HORA
        return res.data.data.map(obj => {
          let { adventure, schedule } = obj;
          schedule = schedule.sort((a,b) => {
            if(moment(a.start, "HH:mm").isAfter(moment(b.start, "HH:mm"))){
              return 1
            }
            if(moment(b.start, "HH:mm").isAfter(moment(a.start, "HH:mm"))){
              return -1
            }
            return 0
          })
          return { adventure, schedule };
        })
      })
      .catch(err => { throw err })
  }
  getRequest(params) {
    return Api.call('/request/get-request', 'get', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getOperatingsByAdventure(params) {
    return Api.call('/operating/get-by-adventure', 'get', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  changeRequest(params) {
    return Api.call('/request/change-request-date', 'post', params)
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getRequestTags(params) {
    return Api.call('/request/get-request-tags', 'get', params) 
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getReserveTags(params) {
    return Api.call('/reserve/get-reserve-tags', 'get', params) 
      .then(res => res.data)
      .catch(err => { throw err })
  }
  saveRequestTags(params) { 
    return Api.call('/request/register-request-tags', 'post', params, false, true) 
      .then(res => res.data)
      .catch(err => { throw err })
  }
  saveReserveTags(params) { 
    return Api.call('/request/register-reserve-tags', 'post', params, false, true) 
      .then(res => res.data)
      .catch(err => { throw err })
  }
  getRequestCustomFieldsForAdventure(pkAdventure) {
    return Api.call('/adventure/get-request-custom-fields', 'get', { pkAdventure })
      .then(res => res.data)
      .catch(err => { throw err })
  }
  
}

export default new RequestsService();


// WEBPACK FOOTER //
// ./src/services/RequestsService.js